import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import { Modal } from 'react-bootstrap';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class ImportIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      data_modal: [],
      errors_listing: false,
      errors_messages: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.import = this.import.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/importacoes/rubi', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            data: responseJson.data,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  import() {
    var self = this;
    if (window.confirm(this.locale.Importacoes.ListaDeImportacoes.atualizarSistemaComInformacoesDoRUBI)) {
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/importar/api/rubi', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.setState({data: responseJson.data});
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.setState({errors_messages: responseJson.data, errors_listing: true});
            self.handleAlert('', '', 'closed');
          }
        }); 
      });
    }
  }


  showModal(id) {
    var self = this;
    self.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/importacoes/logs/' + id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({data_modal: responseJson.data, modal: true});
          self.handleAlert('', '', 'closed');
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }); 
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-info" onClick={() => this.showModal(cell)}>
          <i className="fa fa-fw fa-eye"></i>
        </button>
      </div>
    );

    return botao;
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Importacoes.ListaDeImportacoes.titulo}</h3>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Importacoes.ListaDeImportacoes.naoFoiPossivelRealizarImportacaoDosDadosDoRUBI}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
          <hr />
        </div>
      }
      <hr/>
      <button type="submit" onClick={() => this.import()} className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-upload"></i> {this.locale.Importacoes.ListaDeImportacoes.botaoImportar}</button>
      <div>
        <hr/>
        <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} import={true} multiColumnSearch={true}  importPlaceholder={this.locale.general.procurar}>
          <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='40'>{this.locale.Importacoes.ListaDeImportacoes.tabela.ID}</TableHeaderColumn>
          <TableHeaderColumn dataField={'date_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabela.DataDeImportacao}</TableHeaderColumn>
          <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Importacoes.ListaDeImportacoes.tabela.Acoes}</TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>

    <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
      <Modal.Header>
        <h4 className="pull-left">{this.locale.Importacoes.ListaDeImportacoes.tituloLogDeEdicoes}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, data_modal: [] })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
      </Modal.Header>
      <Modal.Body>
        <BootstrapTable data={this.state.data_modal} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' '}} import={true} multiColumnSearch={true}  importPlaceholder={this.locale.general.procurar}>
          <TableHeaderColumn dataField={'id'} isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='40'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.ID}</TableHeaderColumn>
          <TableHeaderColumn dataField={'staff'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.Colaborador}</TableHeaderColumn>
          <TableHeaderColumn dataField={'type'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.Tipo}</TableHeaderColumn>
          <TableHeaderColumn dataField={'index_rubi'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.Campo}</TableHeaderColumn>
          <TableHeaderColumn dataField={'old_value'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.ValorAntigo}</TableHeaderColumn>
          <TableHeaderColumn dataField={'new_value'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.Importacoes.ListaDeImportacoes.tabelaLogDeEdicoes.ValorNovo}</TableHeaderColumn>
        </BootstrapTable>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, data_modal: [] })}>
        <i className="fa fa-fw fa-close"></i></button>
      </Modal.Footer>
    </Modal>
  </div>
</div>
    );
  }
}

export default ImportIndex;



// WEBPACK FOOTER //
// ./src/Components/Import/ImportIndex.js